import PlateNoDataCard from './PlateNoDataCard';

export default PlateNoDataCard;
